import { css } from 'styled-components';

export const titillium14 = css`
	font-family: 'Titillium Web', sans-serif;
	font-size: 14px;
	line-height: 18px;
	letter-spacing: 0.025em;
	font-weight: bold;
`;

export const titillium15 = css`
	font-family: 'Titillium Web', sans-serif;
	font-size: 15px;
	font-weight: 600;
	letter-spacing: 0.75px;
	line-height: 22px;
`;

export const titillium16 = css`
	font-family: 'Titillium Web', sans-serif;
	font-size: 16px;
	letter-spacing: 0.16px;
	line-height: 27px;
`;

export const titillium17 = css`
	font-family: 'Titillium Web', sans-serif;
	font-size: 17px;
	font-weight: 400;
	line-height: 18px;
`;

export const titillium18 = css`
	font-family: 'Titillium Web', sans-serif;
	font-size: 18px;
	letter-spacing: 0.18px;
	font-weight: 700;
	line-height: 27px;
`;

export const titillium20 = css`
	font-family: 'Titillium Web', sans-serif;
	font-size: 20px;
	font-weight: 400;
	letter-spacing: 0.2px;
	line-height: 27px;
`;

export const titillium22 = css`
	font-family: 'Titillium Web', sans-serif;
	font-size: 22px;
	letter-spacing: 0.22px;
	line-height: 27px;
`;

export const titillium24 = css`
	font-family: 'Titillium Web', sans-serif;
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	letter-spacing: 0.22px;
`;

export const titillium26 = css`
	font-family: 'Titillium Web', sans-serif;
	font-size: 26px;
	letter-spacing: 0.26px;
	line-height: 32px;
`;

export const titillium30 = css`
	font-family: 'Titillium Web', sans-serif;
	font-size: 30px;
	letter-spacing: 0.75px;
	line-height: 38px;
`;

export const titillium32 = css`
	font-family: 'Titillium Web', sans-serif;
	font-size: 32px;
	font-weight: bold;
	letter-spacing: 0.95px;
	line-height: 50px;
`;

export const titillium34 = css`
	font-family: 'Titillium Web', sans-serif;
	font-size: 34px;
	font-weight: 600;
	letter-spacing: 0.34px;
	line-height: 39px;
`;

export const titillium42 = css`
	font-family: 'Titillium Web', sans-serif;
	font-size: 42px;
	font-weight: 600;
	letter-spacing: 1.05px;
	line-height: 46px;
`;

export const titillium48 = css`
	font-family: 'Titillium Web', sans-serif;
	font-size: 48px;
	font-weight: bold;
	letter-spacing: 0.48px;
	line-height: 56px;
`;

export const roboto12 = css`
	font-family: 'Roboto', sans-serif;
	font-size: 12px;
	line-height: 16px;
	letter-spacing: 0.025em;
`;

export const robotoMono11 = css`
	font-family: 'Roboto Mono', sans-serif;
	font-size: 11px;
`;

export const robotoMono13 = css`
	font-family: 'Roboto Mono', sans-serif;
	font-size: 13px;
`;

export const roboto14 = css`
	font-family: 'Roboto', sans-serif;
	font-size: 14px;
	font-weight: 300;
	letter-spacing: 0.35px;
	line-height: 18px;
`;

export const roboto15 = css`
	font-family: 'Roboto', sans-serif;
	font-size: 15px;
	line-height: 20px;
`;

export const roboto16 = css`
	font-family: 'Roboto', sans-serif;
	font-size: 16px;
	font-weight: 300;
	line-height: 20px;
`;

export const roboto18 = css`
	font-family: 'Roboto', sans-serif;
	font-size: 18px;
	font-weight: 300;
	line-height: 26px;
`;

export const lato14 = css`
	font-family: 'Lato', sans-serif;
	font-size: 14px;
	font-weight: 400;
	line-height: 25px;
`;
